<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section intro-section">
    <h2 class="section-title">Assurance Multirisque Immeuble (MRI)<br>Assurance Propriétaire Non Occupant (PNO)</h2>
    <div class="intro-content">
      <p>
        Un propriétaire unique d'immeuble ou un copropriétaire d'immeuble ou un propriétaire d'appartement ou d'une maison, autrement dit celui qui est le propriétaire des <strong>murs (donc du contenant)</strong> doit s'assurer contre les risques pouvant atteindre les murs et /ou les parties <strong>communes de son bien immobilier</strong> grâce à une <strong class="text-purple">assurance multirisque immeuble – MRI – PNO</strong>.
      </p>
      <p>
        Quand ce propriétaire ou copropriétaire des murs occupe les lieux, alors il est assuré par son <strong class="text-purple">Assurance Multirisque Habitation</strong>. En effet, le fait de déclarer à la souscription du contrat d'habitation que l'on est propriétaire, les garanties des murs rentrent dans le contrat. Si le propriétaire des murs n'occupe pas les lieux, il doit quand même assurer les murs. Le locataire quant à lui assure de son côté le contenu du lieu.
      </p>
      <p>
        Cette assurance est obligatoire pour le propriétaire. En effet, ses murs peuvent être <strong>responsables de dommages</strong> envers un tiers (un bout de balcon qui tombe sur un passant en bas du bien immobilier). Par ailleurs, le propriétaire de ces murs a tout intérêt de s'assurer, car en cas d'effondrement, inondation destructrice, incendie destructeur, vent violent, vandalismes par un tiers etc, l'assureur le dédommagera intégralement.
      </p>
      
      <p class="highlight-text">
        Pour compléter l'assurance des biens dont vous êtes propriétaires et que vous mettez en location offrant un loyer, il est souvent opportun de souscrire une assurance <strong class="text-purple">GLI</strong> dite <a href="/assurance-loyers-impayes" class="link-purple">Assurance Loyers Impayés</a>.
      </p>
      
      <p>
        Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, SPVIE AXA, INSURED, ENTORIA, HELVETIA, SWISSLIFE</strong>
      </p>
      
      <div class="cta-box">
        <a href="/contact" class="btn-devis">Devis en ligne PNO</a>
      </div>
    </div>
  </div>

  <div class="content-section who-section">
    <h3 class="section-subtitle">Pour qui ?</h3>
    <p>
      Le propriétaire qui peut être Syndic de copropriété, Association Libre Syndicale, Syndic bénévole, Propriétaire non occupant, Propriétaire occupant partiel, Société Civile Immobilière (SCI), etc. D'ailleurs le propriétaire peut demander à son locataire d'assurer les murs pour son compte s'il le prévoit dans le bail.
    </p>
  </div>

  <div class="content-section risk-section">
    <h3 class="section-subtitle">Type de risque client ?</h3>
    <p>En tant que courtier en assurance nous sommes en mesure de vous assurer quel que soit votre situation :</p>
    <ul class="risk-list">
      <li>Immobilier avec une fréquence SINISTRE,</li>
      <li>Immobilier AVEC sinistres majeurs,</li>
      <li>Immobilier RÉSILIÉS pour non-paiement de prime,</li>
      <li>Immobilier à USAGE D'HABITATION ou de BUREAUX (Immeubles avec présence de commerces représentant moins de <strong class="highlight-purple">25%</strong> de la superficie totale du risque),</li>
      <li>Immobilier de GRANDE HAUTEUR,</li>
      <li>GRANDS ENSEMBLES immobiliers.</li>
    </ul>
  </div>

  <div class="content-section key-points-section">
    <h3 class="section-subtitle">Les points clés du produit :</h3>
    
    <div class="key-point">
      <h4>A) UN PRODUIT COMPLET</h4>
      <p>Permettant de garantir très largement les biens et les responsabilités.</p>
      <p><strong>Quelques exemples :</strong></p>
      <ul>
        <li>Garantie DDE étendue aux canalisations extérieures à l'immeuble, ou à l'appartement à assurer</li>
        <li>Vandalisme extérieur et intérieur des lieux, tags, graffitis,</li>
        <li>Dommages occasionnés aux installations électriques, machines, ascenseurs…,</li>
        <li>Garantie effondrement,</li>
        <li>Garantie RC syndic bénévole,</li>
        <li>Garantie RC du Conseil Syndical étendue à chacun de ses membres,</li>
        <li>Valeur à neuf à <strong class="highlight-purple">33 %</strong></li>
      </ul>
    </div>

    <div class="key-point">
      <h4>B) RENONCIATION À RECOURS</h4>
      <p>Envers le syndic, l'administrateur et l'ensemble des copropriétaires et propriétaires.</p>
    </div>

    <div class="key-point">
      <h4>C) FRANCHISE SUR MESURE</h4>
      <p>Franchise au choix et adaptée à vos besoins.</p>
    </div>

    <div class="key-point">
      <h4>D) GRANDE CAPACITÉ DE SOUSCRIPTION</h4>
      <p>Limitation contractuelle d'indemnité (LCI) sur-mesure.</p>
    </div>

    <div class="key-point">
      <h4>E) TARIFICATION AVANTAGEUSE</h4>
      <ul>
        <li>Tarification modulable en toute autonomie,</li>
        <li>Tarif attractif pour les immeubles neufs venant d'être livrés (sans sinistre).</li>
      </ul>
    </div>
  </div>

  <div class="content-section cta-bottom">
    <a href="/contact" class="btn-devis-bottom">Devis en ligne PNO</a>
  </div>

</app-page-layout>
